import { render, staticRenderFns } from "./DetailCompletedClaims.vue?vue&type=template&id=7d242264"
import script from "../../script/claims/detailsCompletedClaims.js?vue&type=script&lang=js&external"
export * from "../../script/claims/detailsCompletedClaims.js?vue&type=script&lang=js&external"
import style0 from "../../less/claims/detailsClaims.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports